module.exports = __webpack_public_path__ + "static/media/storyline-section-2.772a0234.png";